import React, { useState, useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@material-ui/core";

export function MultiTabAlertDialog({ showModal, toggleModal, handleUseThisTab }) {

  function handleClose() {
    toggleModal(false);
  }

  return (
    <div>
      <Dialog
        open={showModal}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"You are about to make the current tab as your primary tab."}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            - If you are a <strong>SIP</strong> user, clicking on <strong>"Continue"</strong> will terminate the SIP session from the primary tab and establish on the current tab <span style={{ color: 'red' }}>(any ongoing call will automatically be terminated)</span>.
            <br></br>
            <br></br>
            - If you are a <strong>Phone</strong> user, clicking on <strong>"Continue"</strong> will terminate your call pop-up from the primary tab (any ongoing call will not be disconnected).
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
            Cancel
          </Button>
          <Button onClick={() => handleUseThisTab(window?.currentTabId)} color="primary" autoFocus>
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}